module.exports = __webpack_public_path__ + "static/media/sort-up-down.8674cd34.svg";